<template lang="pug">
div.content.body-reg-teacher.background-reg-teacher
  .container
    .row
      .card.reg-teacher-card
        .card-content.reg-teacher-card-content
          div.col-md-12
            div.col-md-4.reg-teacher-img
              img(src="../../assets/Obee_Logo_140@2x.png")
            div.col-md-8.reg-teacher-title ĐĂNG KÝ TÀI KHOẢN GIÁO VIÊN
            itemTeacher1(
              :newParams= 'newParams',
              :schools='schools'
              @continueTeacher="continueTeacher"
              :socialType="socialType"
              :newEmail="email"
              :newFullName="fullname"
              :oldData="getOldData"
              :key="count"
              v-if="secondItemTeacher === false")
            itemTeacher2(
              :newParams= 'newParams',
              :grades='grades'
              :subjects='subjects'
              :dataScreen1='dataScreen1'
              :socialType='socialType'
              @backTeacher1="backScreen"
              v-else)
          .clearfix
            
</template>

<script>
import itemTeacher1 from './itemRegisterTeacher1'
import itemTeacher2 from './itemRegisterTeacher2'
import gql from 'graphql-tag'
import graphql from '../Model/graphql'

export default {
  components: {
    itemTeacher1,
    itemTeacher2
  },
  data() {
    return {
      schools: [],
      secondItemTeacher: false,
      email: '',
      username: '',
      fullname: '',
      socialType: 1,
      dataScreen1: null,
      newParams: this.$route.params,
      count: 0,
      getOldData: null
    }
  },
  methods: {
    continueTeacher(payload) {
      payload.avatar = this.$route.params.newPicture
      if (payload) this.dataScreen1 = payload
      this.secondItemTeacher = true
    },
    forceComponent() {
      this.count++
    },
    backScreen(payload) {
      if (payload) this.getOldData = payload
      this.forceComponent()
      this.secondItemTeacher = false
    }
  },
  created() {
    if (this.$route.params.newEmail) {
      this.email = this.$route.params.newEmail
      this.username = this.$route.params.newEmail
      this.socialType = 2
    }
    if (this.$route.params.newFullName) {
      this.fullname = this.$route.params.newFullName
    }
    this.$store.commit('setIsHomePage', false)
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  apollo: {
    schools: {
      query: gql(graphql.GET_SCHOOLS),
      update: data => data.school,
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    },
    grades: {
      query: gql(graphql.GET_GRADES),
      update: data => {
        for (var i = 0; i < data.grades.length; i++) {
          data.grades[i].selected = false
        }
        return data.grades
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    },
    subjects: {
      query: gql(graphql.GET_SUBJECTS),
      update: data => {
        for (var i = 0; i < data.subjects.length; i++) {
          data.subjects[i].selected = false
        }
        return data.subjects
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.background-reg-teacher{
  background: #FBF4D2 url('../../assets/images/login/bg_pattern.png') no-repeat center 50%;
}
.body-reg-teacher {
  // width: 584px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  font-family: 'adobe-clean', sans-serif;
  padding-top: 0px !important;
  .reg-teacher-card {
    width: 584px;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 10px;
    opacity: 1;
    margin: 25px auto;
    display: block;
    .reg-teacher-card-content {
      padding-left: 10px;
      padding-right: 10px;
      .reg-teacher-title {
        font-weight: bold;
        text-align: center;
        margin-top: 20px;
        // padding-right: 0px;
        font-size: 17px;
      }
      .reg-teacher-img {
        padding: 0;
        width: 140px;
      }
      .reg-teacher-content {
        color: #B4B4B4;
        font-size: 14px;
        span {
          color: #1A0DAB;
          text-decoration: underline;
        }
      }
    }
  }

  // cellphones
  @media (max-width: 414px) {
    .reg-teacher-title {
      text-align: left !important;
      margin-left: -15px !important;
      padding: -10px;
    }
    
  }
}

// cellphones
@media (max-width: 414px) {
  .body-reg-teacher {
    // width: 100%;
    padding: 20px;
    .reg-teacher-card {
      width: 100%;
      .reg-teacher-card-content {
        padding-bottom: 0;
        padding-left: 5px !important;
        padding-right: 5px !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// RegisterTeacher.vue?62a89e18